import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/Auth/Login';
import PrivateRoute from './components/Auth/PrivateRoute';
import UserManagement from './components/Users/UserManagement';
import VendorManagement from './components/Vendors/VendorManagement';
import VoucherSupplierManagement from './components/VoucherSuppliers/VoucherSupplierManagement';
import VoucherManagement from './components/Vouchers/VoucherManagement';
import TransactionManagement from './components/Transactions/TransactionManagement';
import Analytics from './components/Analytics/Analytics';
import SystemManagement from './components/System/SystemManagement';
import Settings from './components/Settings/Settings';
import AppColors from './utils/AppColors';

// Create theme
const theme = createTheme({
  palette: {
    primary: {
      main: AppColors.primaryDark,
    },
    secondary: {
      main: AppColors.primaryYellow,
    },
    background: {
      default: AppColors.backgroundLightGray,
      paper: AppColors.backgroundWhite,
    },
    text: {
      primary: AppColors.textPrimary,
      secondary: AppColors.textSecondary,
    },
  },
  typography: {
    fontFamily: 'Beiruti, Arial, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '50px',
          textTransform: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes */}
            <Route path="/dashboard" element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            } />
            
            <Route path="/users" element={
              <PrivateRoute>
                <Layout>
                  <UserManagement />
                </Layout>
              </PrivateRoute>
            } />
            
            <Route path="/vendors" element={
              <PrivateRoute>
                <Layout>
                  <VendorManagement />
                </Layout>
              </PrivateRoute>
            } />
            
            <Route path="/voucher-suppliers" element={
              <PrivateRoute>
                <Layout>
                  <VoucherSupplierManagement />
                </Layout>
              </PrivateRoute>
            } />
            
            <Route path="/vouchers" element={
              <PrivateRoute>
                <Layout>
                  <VoucherManagement />
                </Layout>
              </PrivateRoute>
            } />
            
            <Route path="/transactions" element={
              <PrivateRoute>
                <Layout>
                  <TransactionManagement />
                </Layout>
              </PrivateRoute>
            } />
            
            <Route path="/analytics" element={
              <PrivateRoute>
                <Layout>
                  <Analytics />
                </Layout>
              </PrivateRoute>
            } />
            
            <Route path="/system" element={
              <PrivateRoute>
                <Layout>
                  <SystemManagement />
                </Layout>
              </PrivateRoute>
            } />
            
            <Route path="/settings" element={
              <PrivateRoute>
                <Layout>
                  <Settings />
                </Layout>
              </PrivateRoute>
            } />
            
            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
